/** @format */

import React, { useRef, useEffect } from 'react';
import './styles.scss';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
// import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

export const ImageFullScreenPopup = ({
  display = false,
  images = [],
  selectedImage = 0,
  setDisplay
}) => {
  const fullScreenImageRef = useRef(null);

  useEffect(() => {
    if (display) {
      fullScreenImageRef.current.toggleFullScreen();
    }
  });

  if (display) {
    return (
      <ImageGallery
        items={images.map((imageData) => {
          return {
            original: imageData.url,
            fullscreen: imageData.url
          };
        })}
        showFullscreenButton={true}
        useBrowserFullscreen={true}
        showPlayButton={false}
        startIndex={selectedImage}
        ref={fullScreenImageRef}
        onScreenChange={(isFullScreen) => {
          if (!isFullScreen) {
            setDisplay(false);
            document.body.classList.remove('hide-sticky');
          } else {
            document.body.classList.add('hide-sticky');
          }
        }}
        // renderItem={(item) => (
        //   <div
        //     className='image-gallery-image'
        //     style={{
        //       touchAction: 'none', // required to enable gestures
        //       height: '100%',
        //       backgroundColor: 'black'
        //     }}>
        //     <TransformWrapper
        //       doubleClick={{ disabled: true }}
        //       pinch={{ disabled: false }}
        //       wheel={{ disabled: true }}
        //       panning={{ disabled: false }}>
        //       <TransformComponent>
        //         <img
        //           src={item.original}
        //           alt=''
        //           style={{
        //             width: '100%',
        //             height: '100%',
        //             objectFit: 'contain'
        //           }}
        //         />
        //       </TransformComponent>
        //     </TransformWrapper>
        //   </div>
        // )}
      />
    );
  }
  return <></>;
};
